import React, { useState, useEffect } from "react";
import type { ViewsConfiguration } from "../../model/Configuration";
import { useViewsConfiguration } from "../../redux/Hooks";
import {
  viewsConfigurationChangeAction,
} from "../../redux/Actions";
import { useDispatchKiosk } from "../../redux/Hooks/Kiosk/useDispatchKiosk";
import { useLocale } from "@davi-ai/retorik-framework";
import translation from '../../translations/subMenuItems.json';
import commonTranslation from '../../translations/common.json';
import Button from "../Common/Button";
import TextField from "./TextField";
import OnOffButtons from "./OnOffButtons";
import BackgroundChoice from "./BackgroundChoice";
import tempViewsConfigurationChangeAction from "../../redux/Actions/Kiosk/tempViewsConfigurationChangeAction";

const InfoChannelChange = () => {
  const locale = useLocale();
  const viewsConfiguration: ViewsConfiguration = useViewsConfiguration();
  const dispatch = useDispatchKiosk();
  const [openingVideo, setOpeningVideo] = useState<string | undefined>(
    typeof viewsConfiguration.views.news?.openingVideo === 'string' ? 
    viewsConfiguration.views.news?.openingVideo : undefined
  );
  const [loop, setLoop] = useState<boolean | undefined>(
    typeof viewsConfiguration.views.news?.loop === 'boolean' ? 
    viewsConfiguration.views.news?.loop : undefined
  );
  const [intervalInSeconds, setIntervalInSeconds] = useState<
    number | undefined
  >(
    typeof viewsConfiguration.views.news?.intervalInSeconds === 'number' ? 
    viewsConfiguration.views.news?.intervalInSeconds : undefined
  );
  const [changed, setChanged] = useState<boolean>(false);

  useEffect(() => {
    setChanged(true);
  }, [openingVideo, loop, intervalInSeconds]);

  useEffect(() => {
    setChanged(false);
  }, []);

  const handleApply = () => {
    const tempData: ViewsConfiguration = { ...viewsConfiguration };
    const background = viewsConfiguration.views.news?.background || {
      style: "image",
    };
    const newsData: any = {
      intervalInSeconds: intervalInSeconds,
      loop: loop,
      openingVideo: openingVideo,
      background: background,
    };
    tempData.views.news = newsData;

    dispatch(viewsConfigurationChangeAction(tempData));
    dispatch(tempViewsConfigurationChangeAction({ news: {
      intervalInSeconds: intervalInSeconds,
      loop: loop,
      openingVideo: openingVideo,
      background: background,
    }}));
    setChanged(false);
  };

  const handleChangeOpeningUrl = (event: React.FormEvent<HTMLInputElement>) => {
    if (event.currentTarget.value === "") {
      setOpeningVideo(undefined);
    } else {
      setOpeningVideo(event.currentTarget.value);
    }
  };

  const handleChangeTimer = (event: React.FormEvent<HTMLInputElement>) => {
    if (event.currentTarget.value === "") {
      setIntervalInSeconds(undefined);
    } else {
      const val = parseInt(event.currentTarget.value);
      val && setIntervalInSeconds(parseInt(event.currentTarget.value));
    }
  };

  return (
    <div className="w-full flex flex-col gap-1 my-1 px-4">
      <TextField
        label={translation[locale]?.news.opening || translation["fr-FR"].news.opening}
        onChange={handleChangeOpeningUrl}
        value={openingVideo}
      />

      <div className="flex flex-row justify-between items-center">
        {translation[locale]?.news.loop || translation["fr-FR"].news.loop}
        <OnOffButtons
          toggle={loop || false}
          returnFunction={() => setLoop(!loop)}
        />
      </div>

      <TextField
        label={translation[locale]?.news.timer || translation["fr-FR"].news.timer}
        onChange={handleChangeTimer}
        value={intervalInSeconds}
      />

      <BackgroundChoice from={"news"} />

      {changed && (
        <div className="flex justify-center mt-1">
          <Button onClick={handleApply} label="Apply">
            {commonTranslation[locale]?.apply || commonTranslation["fr-FR"].apply}
          </Button>
        </div>
      )}
    </div>
  );
};

export default InfoChannelChange;
